import {Image, Text, View} from "react-native";
import {Button} from "../../../../shared/button";
import * as React from "react";
import {filter} from 'lodash'
import {TransparentBox} from "../../../../ui/transparent-box";
import * as PropTypes from "prop-types";

function BinCounter({count = 0, isInDelivery = false}) {
    const binImg = isInDelivery ? require(`../../../../../assets/images/trash-delivery.png`) : require(`../../../../../assets/images/trash.png`)
    return <View style={{alignItems: "center", justifyContent: "center"}}>
        <Image style={{marginLeft: 12}} source={binImg}/>
        <Text style={{position: "absolute", fontWeight: "bold", fontSize: 35, paddingTop: 7, color: "white"}}>
            {count}
        </Text>
    </View>;
}

BinCounter.propTypes = {nbInDelivery: PropTypes.number};
export const MyBins = ({
    onBuyAdditional,
    nbOnSite,
    nbInDelivery
}) => {
    return <TransparentBox marginBottom={30}>
        <View style={{flexDirection: 'column', alignItems: 'center', justifyContent: 'center'}}>
        {/*<Image style={{width: 100, height: 100, marginLeft: -15, resizeMode: 'contain' }}*/}
        {/*       source={require('../../../../../assets/images/trash.gif')}/>*/}
        {/*<Text style={{fontSize: 17, textAlign: 'center', marginTop: 20, marginBottom: 10}}>*/}
        {/*/!*<FontAwesome name='trash' size={50} />*!/*/}

        {/*    My Bins*/}
        {/*</Text>*/}
        </View>

        {/*<View style={{height: 1, backgroundColor: '#405066', marginBottom: 15}} />*/}

        <View style={{flexDirection: 'row', justifyContent: "space-around", marginTop: 20, marginBottom: 20 }}>
            {nbOnSite ? <View style={{alignItems: 'center'}}>
                <BinCounter count={nbOnSite} />
                <Text style={{color: 'white', fontSize: 18, marginTop: 5}}>at my place</Text>
            </View> : null}
            {nbInDelivery ? <View style={{alignItems: 'center'}}>
                <BinCounter count={nbInDelivery} isInDelivery={true} />
                <Text style={{color: 'white', fontSize: 18, marginTop: 5}}>in delivery</Text>
            </View> : null}
        </View>

        <Button appearance="ghost" onPress={onBuyAdditional}>
            Add additional Bin
        </Button>
    </TransparentBox>
}